import { render, staticRenderFns } from "./HasInternet.vue?vue&type=template&id=51e41818&"
import script from "./HasInternet.vue?vue&type=script&lang=ts&"
export * from "./HasInternet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports